import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/login";
import deltas from "../../actions/deltas";

const {SET_LOGIN_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.STATIC, SET_LOGIN_STATE);
